import React, { Component } from "react";

import "./Services.css";
import Doradztwo from "./Doradztwo/Doradztwo";
import Koncepcje from "./Koncepcje/Koncepcje";
import Projekt from "./Projekt/Projekt";
import Wykonawstwo from "./Wykonawstwo/Wykonawstwo";
import Nadzor from "./Nadzor/Nadzor";

class Services extends Component {
  state = {
    opened: 0
  };

  changeCardHandler = value => {
    this.setState({ opened: value });
  };

  render() {
    let classesActive = [
      "col-md p-4 port-item",
      "col-md p-4 port-item",
      "col-md p-4 port-item",
      "col-md p-4 port-item",
      "col-md p-4 port-item"
    ];
    let card = null;
    switch (this.state.opened) {
      case 0:
        classesActive[0] = "col-md p-4 port-item-active";
        card = <Doradztwo />;
        break;
      case 1:
        classesActive[1] = "col-md p-4 port-item-active";
        card = <Koncepcje />;
        break;
      case 2:
        classesActive[2] = "col-md p-4 port-item-active";
        card = <Projekt />;
        break;
      case 3:
        classesActive[3] = "col-md p-4 port-item-active";
        card = <Wykonawstwo />;
        break;
      case 4:
        classesActive[4] = "col-md p-4 port-item-active";
        card = <Nadzor />;
        break;
      default:
        classesActive[0] = "col-md p-4 port-item-active";
        card = <Doradztwo />;
        break;
    }

    return (
      <section id="services-architecture" className="py-3">
        <div className="container p-5">
          <div className="row d-flex flex-row text-white align-items-stretch text-center">
            <div
              className={classesActive[0]}
              onClick={() => this.changeCardHandler(0)}
            >
              <i className="fa fa-comments d-block" /> Doradztwo
            </div>
            <div
              className={classesActive[1]}
              onClick={() => this.changeCardHandler(1)}
            >
              <i className="fa fa-home d-block" /> Koncepcje
            </div>
            <div
              className={classesActive[2]}
              onClick={() => this.changeCardHandler(2)}
            >
              <i className="fa fa-folder-open d-block" /> Projekt
            </div>
            <div
              className={classesActive[3]}
              onClick={() => this.changeCardHandler(3)}
            >
              <i className="fa fa-paint-brush d-block" /> Wykonawstwo
            </div>
            <div
              className={classesActive[4]}
              onClick={() => this.changeCardHandler(4)}
            >
              <i className="fa fa-search d-block" /> Nadzór
            </div>
          </div>
          {card}
        </div>
      </section>
    );
  }
}

export default Services;



// WEBPACK FOOTER //
// ./src/components/Architecture/Services/Services.js